<template>
    <div class="grid max-w-2xl grid-cols-1 gap-x-4 gap-y-4 py-2">
        <BaseInputCheckbox
            v-model="checkAll"
            class="border-b border-gray-300 pb-4 font-semibold"
            :label="$t('acknowledgements.check_all')"
            name="account.acknowledgements.check_all"></BaseInputCheckbox>
        <AcknowledgementsTwoFormFields></AcknowledgementsTwoFormFields>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BaseInputCheckbox from '../../../base/BaseInputCheckbox.vue'
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { getNaturalWidgetFormValidationRules, initializeNaturalWidgetForm } from './forms'
import AcknowledgementsTwoFormFields from './acknowledgements/AcknowledgementsTwoFormFields.vue'

const { naturalProfile: account } = usePersonalAccountDataState()

const checkAll = computed({
    get() {
        return (
            account.compliance_profiles.esac.acknowledgements.tax_data_exchange_agreement &&
            account.compliance_profiles.esac.acknowledgements.report_changes &&
            account.compliance_profiles.esac.acknowledgements.complete_and_correct_information &&
            account.compliance_profiles.esac.acknowledgements.self_certification_form
        )
    },
    // setter
    set(newValue) {
        if (newValue) {
            account.compliance_profiles.esac.acknowledgements.tax_data_exchange_agreement = true
            account.compliance_profiles.esac.acknowledgements.report_changes = true
            account.compliance_profiles.esac.acknowledgements.complete_and_correct_information = true
            account.compliance_profiles.esac.acknowledgements.self_certification_form = true
        } else {
            account.compliance_profiles.esac.acknowledgements.tax_data_exchange_agreement = false
            account.compliance_profiles.esac.acknowledgements.report_changes = false
            account.compliance_profiles.esac.acknowledgements.complete_and_correct_information = false
            account.compliance_profiles.esac.acknowledgements.self_certification_form = false
        }
    },
})

const formTwoFields: string[] = [
    'acknowledgements.tax_data_exchange_agreement',
    'acknowledgements.report_changes',
    'acknowledgements.complete_and_correct_information',
    'acknowledgements.self_certification_form',
]
const allAcknowledgementRules = getNaturalWidgetFormValidationRules('acknowledgements')

const acknowledgementsTwoFormValidations = Object.keys(allAcknowledgementRules)
    .filter((key) => formTwoFields.includes(key))
    .reduce((obj, key) => {
        obj[key] = allAcknowledgementRules[key]
        return obj
    }, {})

initializeNaturalWidgetForm(acknowledgementsTwoFormValidations)
</script>
